// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-console */
export default () => (next) => (action) => {
  try {
    return next(action)
  } catch (err) {
    console.error("Exception!", err)
    throw err
  }
}
